// Session management for anonymous users
// File: utils/session-manager.ts

/**
 * Gets or creates a session ID for anonymous users
 * Stores it in localStorage for persistence across page reloads
 */
export function getOrCreateSessionId(): string | null {
  if (typeof window === 'undefined') return null;
  
  let sessionId = localStorage.getItem('storybaib_session_id');
  if (!sessionId) {
    sessionId = 'sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem('storybaib_session_id', sessionId);
  }
  return sessionId;
}

/**
 * Clears the current session (used when user signs up/logs in)
 */
export function clearSession(): void {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('storybaib_session_id');
  }
}

/**
 * Gets the current session ID without creating a new one
 */
export function getCurrentSessionId(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem('storybaib_session_id');
}

/**
 * Sets a custom session ID (used for testing or specific cases)
 */
export function setSessionId(sessionId: string): void {
  if (typeof window !== 'undefined') {
    localStorage.setItem('storybaib_session_id', sessionId);
  }
}
